import { memo } from 'react';
import { t } from 'i18next';
import { Stack } from '@mui/system';
import { Divider } from '@mui/material';

import { useReadSelectedObstacles } from '@/modules/floorplanDesign/hooks';
import { useSelectionBasedRenderKey } from '@/modules/common/hooks';
import { Accordion } from '@common/components/Accordion';

import Appearance from './obstacle/Appearance';
import Height from './obstacle/Height';
import { ObstacleDimensions } from './ObstacleDimensions';

function ObstacleParametersComponent() {
  const selectedObstacles = useReadSelectedObstacles();
  const selectedObstacle =
    selectedObstacles.length === 1 ? selectedObstacles[0] : null;
  const { renderKey } = useSelectionBasedRenderKey(selectedObstacle ? [selectedObstacle.id] : []);

  return (
    <Stack spacing={1} divider={<Divider />} key={renderKey}>
      <ObstacleDimensions />
      <Accordion
        title={t<string>('interface:properties.obstacle.obstacle_title', 'Obstacle')}
        unmountOnExit
        defaultExpanded
        sx={{ px: 2 }}
      >
        <Stack direction='column' spacing={1} pb={2}>
          <Appearance />
          <Height />
        </Stack>
      </Accordion>
    </Stack>
  );
}

export const ObstacleParameters = memo(ObstacleParametersComponent);
